/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "userjourney": {
                "nested": {
                  "UserJourneySignal": {
                    "fields": {
                      "outcome": {
                        "type": ".squareup.bbfrontend.common.userjourney.UserJourneySignal.Outcome",
                        "id": 3,
                        "rule": "optional"
                      },
                      "variant": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "journeyName": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "tags": {
                        "type": "string",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "frustration": {
                        "type": "string",
                        "id": 1
                      },
                      "friction": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Outcome": {
                        "values": {
                          "DO_NOT_USE_OUTCOME": 0,
                          "SUCCEEDED": 1,
                          "FAILED": 2,
                          "USER_CANCELLED": 3
                        }
                      },
                      "signal": {
                        "oneof": ["frustration", "friction"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.userjourney?.nested?.UserJourneySignal && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.userjourney?.nested?.UserJourneySignal?.nested?.Outcome) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UserJourneySignal @ squareup/bbfrontend/common/userjourney/user_journey_signal.proto at 8:1
 */
export const UserJourneySignal = $root.lookupType('squareup.bbfrontend.common.userjourney.UserJourneySignal');
fixType(UserJourneySignal);
Builder.createAndAttachToType(UserJourneySignal);
/**
 * SOURCE Outcome @ squareup/bbfrontend/common/userjourney/user_journey_signal.proto at 9:3
 */
UserJourneySignal.Outcome = $root.lookupEnum('squareup.bbfrontend.common.userjourney.UserJourneySignal.Outcome').values;